export default {
      id: "flash-usage",
      viewBox: "0 0 137 41",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#flash",
      toString: function () {
        return this.url;
      }
    }